import { render } from "./ProductCard.vue?vue&type=template&id=6793cd46"
import script from "./ProductCard.vue?vue&type=script&lang=js"
export * from "./ProductCard.vue?vue&type=script&lang=js"

import "./ProductCard.vue?vue&type=style&index=0&id=6793cd46&lang=css"
script.render = render

export default script